import React from 'react';
import { useNavigate } from 'react-router-dom';

import { XMark } from 'assets/icons/Icons';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Text } from 'components/v2/Typography/Text';
import theme from 'kb-shared/theme';
import { pageUrl } from 'utilities/pageUrl';

import { useMedicalRecordsAnnouncement } from './MedicalRecordsAnnouncement.hooks';
import { Announcement, Container, DismissButton } from './MedicalRecordsAnnouncement.styled';

export const MedicalRecordsAnnouncement = () => {
  const navigate = useNavigate();
  const { visible, dismiss, dismissing, dismissError } = useMedicalRecordsAnnouncement();

  const goToDocuments = async () => {
    if (await dismiss()) navigate(`${pageUrl.documents()}?tab=medical-records`);
  };

  if (!visible) return null;

  return (
    <Container aria-label="Medical records announcement">
      <Announcement
        type="info"
        size="md"
        message="You can now download your medical records directly from your documents tab."
        actions={
          <Button
            type="button"
            category="secondary"
            label="Go to Documents"
            onClick={goToDocuments}
            isDisabled={dismissing}
          />
        }
      />
      <DismissButton
        type="button"
        category="tertiary"
        size="sm"
        aria-label="Dismiss medical records announcement"
        isDisabled={dismissing}
        onClick={() => dismiss()}
        leftIcon={<XMark type="solid" aria-hidden="true" />}
      />
      {dismissError ? (
        <div role="alert">
          <Text tag="p" size="sm" color={theme.colors.semantic.darkRed}>
            We couldn't save your preference. Please try again.
          </Text>
        </div>
      ) : null}
    </Container>
  );
};
